"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Subject_1 = require("rxjs/Subject");
var BaseDrawerControlComponent = /** @class */ (function () {
    function BaseDrawerControlComponent() {
        this._destroy$ = new Subject_1.Subject();
    }
    BaseDrawerControlComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    return BaseDrawerControlComponent;
}());
exports.BaseDrawerControlComponent = BaseDrawerControlComponent;
//# sourceMappingURL=base-drawer-control.component.js.map